import { render, staticRenderFns } from "./AlertFrequency.vue?vue&type=template&id=5f338f7b&"
import script from "./AlertFrequency.vue?vue&type=script&lang=js&"
export * from "./AlertFrequency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports